import BaseService from '_services/rest/base';

/* eslint-disable new-parens */
class MagazineService extends BaseService {
  constructor() {
    super();
  }

  getUrl() {
    return `${super.getUrl()}api/magazine`;
  }

  getUrlSave(id) {
    if (id) {
      return {
        url: `${this.getUrl()}/${id}`,
      };
    }
    return {
      url: `${this.getUrl()}`,
    };
  }

  getList(params) {
    const filters = { search: params.search, type: params.type_id, status: params.status_id };

    return this.request(`${this.getUrl()}/all/${params.skip}/${params.take}`, filters)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getTypesList() {
    return this.request(`${this.getUrl()}/type`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getLevelsList() {
    return this.request(`${this.getUrl()}/level`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getStatusList() {
    return this.request(`${this.getUrl()}/status`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getMagazineById(id) {
    return this.request(`${this.getUrl()}/${id}`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  deleteMagazine(id) {
    return this.request(`${this.getUrl()}/${id}`, null, 'DELETE')
      .catch(err => {
        throw err;
      });
  }

  save(model) {
    let formData = new FormData();
    const puzzles = model.puzzles.map(puzzle => ({ id: puzzle.id }));
    model.puzzles = puzzles;
    formData = this.setFormData(model, formData);
    const meta = this.getUrlSave(model.id);
    return this.request(meta.url, formData, 'post')
      .catch(err => {
        throw err;
      });
  }

  getAttachedMagazinePuzzles(params) {
    const { filters } = params;
    const data = { orderby: filters.orderby, type_id: filters.type_id, search: filters.search };
    return this.request(`${this.getUrl()}/${params.id}/puzzles/${filters.skip}/${filters.take}`, data)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  syncPuzzles(data, id) {
    return this.request(`${this.getUrl()}/${id}/sync-puzzle`, data, 'patch')
      .catch(err => {
        throw err;
      });
  }
}

export default new MagazineService();
